<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Banner Download</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Banner Download</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Name"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.name"
              name="name"
              data-vv-as="Name"
              id="input-1"
              class="form-control"
              placeholder="Name"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image Webp (Desktop)"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image Webp (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktopWebp"
                    name="imagedesktopwebp"
                    v-validate="items.image_desktop_webp ?
                    'minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:webp':
                    'required|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:webp'"
                    style="display: none"
                    v-on:change="onChangeFileDesktopWebp()"
                  />
                  <b-button
                    @click="$refs.fileDesktopWebp.click()"
                    v-show="!items.image_desktop_webp && !fileDesktopWebp"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_desktop_webp || fileDesktopWebp"
                    variant="primary"
                    @click="modalDesktopWebp = !modalDesktopWebp"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktopWebp.click()"
                    v-show="items.image_desktop_webp || fileDesktopWebp"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagedesktopwebp') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image Webp (Mobile)"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image Webp (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobileWebp"
                    name="imagemobilewebp"
                    v-validate="items.image_mobile_webp ?
                    'minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:webp' :
                    'required|minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:webp'"
                    style="display: none"
                    v-on:change="onChangeFileMobileWebp()"
                  />
                  <b-button
                    @click="$refs.fileMobileWebp.click()"
                    v-show="!items.image_mobile_webp && !fileMobileWebp"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_mobile_webp || fileMobileWebp"
                    variant="primary"
                    @click="modalMobileWebp = !modalMobileWebp"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobileWebp.click()"
                    v-show="items.image_mobile_webp || fileMobileWebp"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagemobilewebp') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image PNG/JPG (Desktop)"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image PNG/JPG (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktopJpgPng"
                    name="imagedesktopjpgpng"
                    v-validate="items.image_desktop_jpg_png ?
                    'image|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,jpeg' :
                    'required|image|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileDesktopJpgPng()"
                  />
                  <b-button
                    @click="$refs.fileDesktopJpgPng.click()"
                    v-show="!items.image_desktop_jpg_png && !fileDesktopJpgPng"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_desktop_jpg_png || fileDesktopJpgPng"
                    variant="primary"
                    @click="modalDesktopJpgPng = !modalDesktopJpgPng"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktopJpgPng.click()"
                    v-show="items.image_desktop_jpg_png || fileDesktopJpgPng"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagedesktopjpgpng') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Banner Image PNG/JPG (Mobile)"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image PNG/JPG (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobileJpgPng"
                    name="imagemobilejpgpng"
                    v-validate="items.image_mobile_jpg_png ?
                    'image|minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,jpeg' :
                    'required|image|minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileMobileJpgPng()"
                  />
                  <b-button
                    @click="$refs.fileMobileJpgPng.click()"
                    v-show="!items.image_mobile_jpg_png && !fileMobileJpgPng"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_mobile_jpg_png || fileMobileJpgPng"
                    variant="primary"
                    @click="modalMobileJpgPng = !modalMobileJpgPng"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobileJpgPng.click()"
                    v-show="items.image_mobile_jpg_png || fileMobileJpgPng"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagemobilejpgpng') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Image Mockup"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Image Mockup</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(315px x 502px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMockup"
                    name="imagemockup"
                    v-validate="items.image_mockup ?
                    'image|minimalDimensions:315,502|ratiolDimensions:315,502|size:2000|ext:jpg,png,jpeg' :
                    'required|image|minimalDimensions:315,502|ratiolDimensions:315,502|size:2000|ext:jpg,png,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileMockup()"
                  />
                  <b-button
                    @click="$refs.fileMockup.click()"
                    v-show="!items.image_mockup && !fileMockup"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_mockup || fileMockup"
                    variant="primary"
                    @click="modalMockup = !modalMockup"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMockup.click()"
                    v-show="items.image_mockup || fileMockup"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagemockup') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.heading.id"
              name="title_id"
              data-vv-as="Heading Bahasa"
              id="input-1"
              class="form-control"
              placeholder="Heading In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.heading.en"
              name="title_en"
              data-vv-as="Heading English"
              class="form-control"
              placeholder="Heading In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Hashtags (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.hashtags.id"
              name="title_id"
              data-vv-as="Hashtags (Bahasa)"
              id="input-1"
              class="form-control"
              placeholder="Hashtags (Bahasa)"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Hashtags (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.hashtags.en"
              name="title_en"
              data-vv-as="Hashtags (English)"
              class="form-control"
              placeholder="Hashtags (English)"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              placeholder="Sub Heading in Bahasa"
              v-model="items.sub_heading.id"
              data-vv-as="Sub Heading Bahasa"
              v-validate="'required'"
              name="sub_heading_id"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-sub_heading_id-feedback">{{ veeErrors.first('sub_heading_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              placeholder="Sub Heading in English"
              v-model="items.sub_heading.en"
              v-validate="'required'"
              name="content_en"
              data-vv-as="Sub Heading English"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-sub_heading_en-feedback">{{ veeErrors.first('sub_heading_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="Image QR Code"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Image QR Code</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(140px x 140px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileQR"
                    name="imageqr"
                    v-validate="items.image_qr ?
                    'image|minimalDimensions:140,140|ratiolDimensions:1,1|size:2000|ext:jpg,png,jpeg' :
                    'required|image|minimalDimensions:140,140|ratiolDimensions:1,1|size:2000|ext:jpg,png,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileQR()"
                  />
                  <b-button
                    @click="$refs.fileQR.click()"
                    v-show="!items.image_qr && !fileQR"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_qr || fileQR"
                    variant="primary"
                    @click="modalQR = !modalQR"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileQR.click()"
                    v-show="items.image_qr || fileQR"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imageqr') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="PlayStore Button"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>PlayStore Button</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(194px x 58px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="filePlayStore"
                    name="imageplaystore"
                    v-validate="items.image_play_store ?
                    'image|minimalDimensions:194,58|ratiolDimensions:97,29|size:2000|ext:jpg,png,jpeg' :
                    'required|image|minimalDimensions:194,58|ratiolDimensions:97,29|size:2000|ext:jpg,png,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFilePlayStore()"
                  />
                  <b-button
                    @click="$refs.filePlayStore.click()"
                    v-show="!items.image_play_store && !filePlayStore"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_play_store || filePlayStore"
                    variant="primary"
                    @click="modalPlayStore = !modalPlayStore"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.filePlayStore.click()"
                    v-show="items.image_play_store || filePlayStore"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imageplaystore') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label="AppStore Button"
            label-for="input-1"
            label-class="control-label"
            class="required">
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>AppStore Button</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(194px x 58px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileAppStore"
                    name="imageappstore"
                    v-validate="items.image_app_store ?
                    'image|minimalDimensions:194,58|ratiolDimensions:97,29|size:2000|ext:jpg,png,jpeg' :
                    'required|image|minimalDimensions:194,58|ratiolDimensions:97,29|size:2000|ext:jpg,png,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileAppStore()"
                  />
                  <b-button
                    @click="$refs.fileAppStore.click()"
                    v-show="!items.image_app_store && !fileAppStore"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_app_store || fileAppStore"
                    variant="primary"
                    @click="modalAppStore = !modalAppStore"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileAppStore.click()"
                    v-show="items.image_app_store || fileAppStore"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imageappstore') }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <input
              placeholder="PlayStore URL"
              v-model="items.play_store_url"
              data-vv-as="PlayStore URL"
              v-validate="'required'"
              name="play_store_url"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-play_store_url-feedback">{{ veeErrors.first('play_store_url') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <input
              placeholder="AppStore URL"
              v-model="items.app_store_url"
              v-validate="'required'"
              name="app_store_url"
              data-vv-as="AppStore URL"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-app_store_url-feedback">{{ veeErrors.first('app_store_url') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobileWebp" title="Preview Image" size="xl">
      <img
        v-show="!fileMobileWebp"
        v-if="items.image_mobile_webp"
        width
        height="400px"
        :src="items.image_mobile_webp"
      />
      <img v-show="fileMobileWebp" v-if="urlMobileWebp" width height="400px" :src="urlMobileWebp" />
    </b-modal>
    <b-modal v-model="modalDesktopWebp" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktopWebp"
        v-if="items.image_desktop_webp"
        width
        height="400px"
        :src="items.image_desktop_webp"
      />
      <img v-show="fileDesktopWebp" v-if="urlDesktopWebp" width height="400px" :src="urlDesktopWebp" />
    </b-modal>
    <b-modal v-model="modalMobileJpgPng" title="Preview Image" size="xl">
      <img
        v-show="!fileMobileJpgPng"
        v-if="items.image_mobile_jpg_png"
        width
        height="400px"
        :src="items.image_mobile_jpg_png"
      />
      <img v-show="fileMobileJpgPng" v-if="urlMobileJpgPng" width height="400px" :src="urlMobileJpgPng" />
    </b-modal>
    <b-modal v-model="modalDesktopJpgPng" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktopJpgPng"
        v-if="items.image_desktop_jpg_png"
        width
        height="400px"
        :src="items.image_desktop_jpg_png"
      />
      <img v-show="fileDesktopJpgPng" v-if="urlDesktopJpgPng" width height="400px" :src="urlDesktopJpgPng" />
    </b-modal>
    <b-modal v-model="modalMockup" title="Preview Image" size="lg">
      <img
        v-show="!fileMockup"
        v-if="items.image_mockup"
        width
        height="400px"
        :src="items.image_mockup"
      />
      <img v-show="fileMockup" v-if="urlMockup" width height="400px" :src="urlMockup" />
    </b-modal>
    <b-modal v-model="modalQR" title="Preview Image" size="lg">
      <img
        v-show="!fileQR"
        v-if="items.image_qr"
        width
        height="140px"
        :src="items.image_qr"
      />
      <img v-show="fileQR" v-if="urlQR" width height="140px" :src="urlQR" />
    </b-modal>
    <b-modal v-model="modalPlayStore" title="Preview Image" size="sm">
      <img
        v-show="!fileQR"
        v-if="items.image_play_store"
        width
        height="58px"
        :src="items.image_play_store"
      />
      <img v-show="filePlayStore" v-if="urlPlayStore" width height="58px" :src="urlPlayStore" />
    </b-modal>
    <b-modal v-model="modalAppStore" title="Preview Image" size="sm">
      <img
        v-show="!fileAppStore"
        v-if="items.image_app_store"
        width
        height="58px"
        :src="items.image_app_store"
      />
      <img v-show="fileAppStore" v-if="urlAppStore" width height="58px" :src="urlAppStore" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      widthImage: null,
      heightImage: null,
      loading: false,
      items: [],
      urlImage: "",
      modalImage: false,
      image: "",
      modalMobileWebp: false,
      modalDesktopWebp: false,
      modalMobileJpgPng: false,
      modalDesktopJpgPng: false,
      modalMockup: false,
      modalQR: false,
      modalPlayStore: false,
      modalAppStore: false,
      fileDesktopWebp: "",
      fileDesktopJpgPng: "",
      fileMobileWebp: "",
      fileMobileJpgPng: "",
      fileMockup: "",
      fileQR: "",
      filePlayStore: "",
      fileAppStore: "",
      urlDesktopWebp: "",
      urlDesktopJpgPng: "",
      urlMobileWebp: "",
      urlMobileJpgPng: "",
      urlMockup: "",
      urlQR: "",
      urlPlayStore: "",
      urlAppStore: ""
    };
  },
  beforeCreate() {
    this.$store.dispatch("BannerDownloadModule/getDownloadBanner");
  },
  created() {
    this.$store.watch(
      state => state.BannerDownloadModule.download_banner,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Download Banner!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("name", this.items.name);
              formData.append("heading_id", this.items.heading.id);
              formData.append("heading_en", this.items.heading.en);
              formData.append("sub_heading_id", this.items.sub_heading.id);
              formData.append("sub_heading_en", this.items.sub_heading.en);
              formData.append("hashtags_id", this.items.hashtags.id);
              formData.append("hashtags_en", this.items.hashtags.en);
              formData.append("image_desktop_webp", this.fileDesktopWebp);
              formData.append("image_mobile_webp", this.fileMobileWebp);
              formData.append("image_desktop_jpg_png", this.fileDesktopJpgPng);
              formData.append("image_mobile_jpg_png", this.fileMobileJpgPng);
              formData.append("image_mockup", this.fileMockup);
              formData.append("image_qr", this.fileQR);
              formData.append("image_play_store", this.filePlayStore);
              formData.append("image_app_store", this.fileAppStore);
              formData.append("play_store_url", this.items.play_store_url);
              formData.append("app_store_url", this.items.app_store_url);
              this.$store
                .dispatch(
                  "BannerDownloadModule/postDownloadBanner",
                  formData
                )
                .then(response => {
                  this.loading = false;
                  this.$validator.reset();
                  this.$router.push({ name: "editBannerDownload" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your data cant be submit, please check again.", "warning");
            }
          });
        }
      });
    },
    onChangeFileDesktopWebp() {
      this.fileDesktopWebp = this.$refs.fileDesktopWebp.files[0];
      const input = this.$refs.fileDesktopWebp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlDesktopWebp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileDesktopJpgPng() {
      this.fileDesktopJpgPng = this.$refs.fileDesktopJpgPng.files[0];
      const input = this.$refs.fileDesktopJpgPng;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlDesktopJpgPng = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobileWebp() {
      this.fileMobileWebp = this.$refs.fileMobileWebp.files[0];
      const input = this.$refs.fileMobileWebp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMobileWebp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobileJpgPng() {
      this.fileMobileJpgPng = this.$refs.fileMobileJpgPng.files[0];
      const input = this.$refs.fileMobileJpgPng;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMobileJpgPng = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMockup() {
      this.fileMockup = this.$refs.fileMockup.files[0];
      const input = this.$refs.fileMockup;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMockup = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileQR() {
      this.fileQR = this.$refs.fileQR.files[0];
      const input = this.$refs.fileQR;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlQR = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFilePlayStore() {
      this.filePlayStore = this.$refs.filePlayStore.files[0];
      const input = this.$refs.filePlayStore;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlPlayStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileAppStore() {
      this.fileAppStore = this.$refs.fileAppStore.files[0];
      const input = this.$refs.fileAppStore;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlAppStore = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
